// area data from https://censusindia.gov.in/2011census/A-1_NO_OF_VILLAGES_TOWNS_HOUSEHOLDS_POPULATION_AND_AREA.xlsx

export default [
  { name: "India", area: 3287263 },
  { x: 3, y: 6, type: "state", id: "AP", name: "Andhra Pradesh", area: 275045 },
  {
    x: 7,
    y: 2,
    type: "state",
    id: "AR",
    name: "Arunachal Pradesh",
    area: 83743,
  },
  { x: 6, y: 3, type: "state", id: "AS", name: "Assam", area: 78438 },
  { x: 4, y: 3, type: "state", id: "BR", name: "Bihar", area: 94163 },
  { x: 3, y: 4, type: "state", id: "CG", name: "Chhattisgarh", area: 135192 },
  { x: 2, y: 6, type: "state", id: "GA", name: "Goa", area: 3702 },
  { x: 0, y: 4, type: "state", id: "GJ", name: "Gujarat", area: 196244 },
  { x: 1, y: 3, type: "state", id: "HR", name: "Haryana", area: 44212 },
  {
    x: 2,
    y: 1,
    type: "state",
    id: "HP",
    name: "Himachal Pradesh",
    area: 55673,
  },
  { x: 4, y: 4, type: "state", id: "JH", name: "Jharkhand", area: 79716 },
  { x: 2, y: 7, type: "state", id: "KA", name: "Karnataka", area: 191791 },
  { x: 2, y: 8, type: "state", id: "KL", name: "Kerala", area: 38852 },
  { x: 2, y: 4, type: "state", id: "MP", name: "Madhya Pradesh", area: 308252 },
  {
    x: 1,
    y: 5,
    type: "state",
    id: "DN",
    name: "Dadra & Nagar Haveli",
    area: 491,
  },
  { x: 7, y: 4, type: "state", id: "MN", name: "Manipur", area: 22327 },
  { x: 6, y: 4, type: "state", id: "ML", name: "Meghalaya", area: 22429 },
  { x: 7, y: 5, type: "state", id: "MZ", name: "Mizoram", area: 21081 },
  { x: 7, y: 3, type: "state", id: "NL", name: "Nagaland", area: 16579 },
  { x: 3, y: 5, type: "state", id: "OD", name: "Odisha", area: 155707 },
  { x: 1, y: 2, type: "state", id: "PB", name: "Punjab", area: 50362 },
  { x: 0, y: 3, type: "state", id: "RJ", name: "Rajasthan", area: 342239 },
  { x: 5, y: 2, type: "state", id: "SK", name: "Sikkim", area: 7096 },
  { x: 3, y: 7, type: "state", id: "TN", name: "Tamil Nadu", area: 130060 },
  { x: 2, y: 5, type: "state", id: "MH", name: "Maharashtra", area: 307713 },
  { x: 6, y: 5, type: "state", id: "TR", name: "Tripura", area: 10486 },
  { x: 3, y: 3, type: "state", id: "UP", name: "Uttar Pradesh", area: 240928 },
  { x: 3, y: 2, type: "state", id: "UT", name: "Uttarakhand", area: 53483 },
  { x: 5, y: 3, type: "state", id: "WB", name: "West Bengal", area: 88752 },
  {
    x: 7,
    y: 8,
    type: "union territory",
    id: "AN",
    name: "Andaman & Nicobar Islands",
    area: 8249,
  },
  {
    x: 2,
    y: 2,
    type: "union territory",
    id: "CH",
    name: "Chandigarh",
    area: 114,
  },
  {
    x: 1,
    y: 4,
    type: "union territory",
    id: "DD",
    name: "Daman & Diu",
    area: 111,
  },
  {
    x: 1,
    y: 1,
    type: "union territory",
    id: "JK",
    name: "Jammu & Kashmir",
    area: 222236,
  },
  {
    x: 0,
    y: 8,
    type: "union territory",
    id: "LD",
    name: "Lakshadweep",
    area: 30,
  },
  {
    x: 2,
    y: 3,
    type: "union territory",
    id: "DL",
    name: "Nct Of Delhi",
    area: 1483,
  },
  {
    x: 3,
    y: 8,
    type: "union territory",
    id: "PY",
    name: "Puducherry",
    area: 490,
  },
];
